var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('strong',{staticClass:"sjt"},[_c('span',{domProps:{"innerHTML":_vm._s(`${_vm.episodeNumber}. `)}}),_c('em',{domProps:{"innerHTML":_vm._s(_vm.episodeTitle || '에피소드')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }